<template>
    <div>
        <div v-if="this.getHostStatus.scheduledDowntimeDepth === 0">
            <b-form-group
                :label="$t('forms.downtimetype')"
                label-for="downtimeType">
                <b-form-select id="downtimeType" v-model="downtimeTypeSelected"
                               :options="downtimetypeOptions"></b-form-select>
            </b-form-group>
            <b-form-group
                :label="$t('comment')"
                label-for="downtimeComment">
                <b-form-input id="downtimeComment" :class="{ 'is-invalid': v$.downtimeComment.$error }"
                              v-model.trim="v$.downtimeComment.$model" placeholder="Commment"></b-form-input>
                <div class="invalid-feedback" v-if="v$.downtimeComment.required">{{ $t('Field is required') }}</div>
            </b-form-group>
            <b-form-group>
                <label for="downtimeStart">Start</label>
                <b-form-input :class="{ 'is-invalid': v$.downtimeStartTime.$error }"
                              v-model.trim="v$.downtimeStartTime.$model" type="datetime-local"></b-form-input>
                <div class="invalid-feedback" v-if="v$.downtimeStartTime.required">{{ $t('Field is required') }}</div>
            </b-form-group>
            <b-form-group>
                <label for="downtimeEnd">{{ $t('end') }}</label>
                <b-form-input :class="{ 'is-invalid': v$.downtimeEndTime.$error }"
                              v-model.trim="v$.downtimeEndTime.$model" type="datetime-local"></b-form-input>
                <div class="invalid-feedback" v-if="v$.downtimeEndTime.required">{{ $t('Field is required') }}</div>
            </b-form-group>

            <b-button variant="success" class="w-100" v-on:click="sendDowntimeCommand">{{ $t('forms.send-command') }}</b-button>
        </div>
        <div v-if="this.getHostStatus.scheduledDowntimeDepth > 0">
            <b-form-group
                description="This will also remove all current Service downtimes from this host"
                label-for="removeHostServiceDowntime">
                <BFormCheckbox
                    id="removeHostServiceDowntime"
                    v-model="removeServiceDowntimes"
                    name="hostServiceDowntimesCheckbox">
                    {{ $t('Remove Service Maintenance') }}
                </BFormCheckbox>
            </b-form-group>
            <b-button variant="danger" class="w-100" v-on:click="sendRemoveDowntimeCommand">{{ $t('Cancel downtime') }}</b-button>
        </div>
    </div>
</template>

<script>

/*
SCHEDULE_HOST_DOWNTIME
SCHEDULE_HOST_SVC_DOWNTIME
SCHEDULE_AND_PROPAGATE_HOST_DOWNTIME
SCHEDULE_AND_PROPAGATE_TRIGGERED_HOST_DOWNTIME


 */

import { required } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'
import { useToast } from "vue-toastification";

export default {
    name: "HostDowntime",
    data(){
        return {
            downtimeTypeSelected: 0,
            downtimetypeOptions: [
                {
                    value:  0,//'SCHEDULE_HOST_DOWNTIME',
                    text: this.$t('hosts.individual')
                },
                {
                    value: 1, //'SCHEDULE_HOST_SVC_DOWNTIME',
                    text: this.$t('hosts.including-services')
                },
                {
                    value: 2, //'SCHEDULE_AND_PROPAGATE_TRIGGERED_HOST_DOWNTIME',
                    text: this.$t('hosts.dependent-triggered')
                },
                {
                    value:  3,//'SCHEDULE_AND_PROPAGATE_HOST_DOWNTIME',
                    text: this.$t('hosts.dependent-not-triggered')
                },

            ],
            downtimeComment: 'in progress',
            downtimeStartTime: '',
            downtimeEndTime: '',
            removeServiceDowntimes: true
        }
    },
    setup: () => ({ v$: useVuelidate() }),
    props: [
        'hostuuid',
        'downtime',
        'hoststatus'
    ],
    validations: {
        downtimeTypeSelected: {
            required
        },
        downtimeComment: {
            required,
        },
        downtimeStartTime: {
            required
        },
        downtimeEndTime: {
            required
        }
    },
    methods: {
        sendRemoveDowntimeCommand: function(){
            let downtime =
                {
                    downtimeType: 'downtime',
                    downtimeId: this.getDowntime.internalDowntimeId,
                    includeServices: this.removeServiceDowntimes
                };
            axios.post('/downtimes/delete.json', downtime)
                .then(response => {
                    if(response.data.response.hasOwnProperty('error')){
                        useToast().error(this.$t('error'), {
                            timeout: 2000
                        });
                        return;
                    }
                    useToast().success(this.$t('Downtime successfully cancelled'), {
                        timeout: 7000
                    });
                    this.$emit('refresh', 'ScheduleMaintenance');
                })
                .catch(error => {
                    useToast().error(this.$t('error'), {
                        timeout: 2000
                    });
                });
        },
        sendDowntimeCommand: async function(){
            this.v$.$touch();
            const validated = await this.v$.$validate();
            if(!validated){
                return;
            }

            var externalCommand = [
                {
                    command: 'submitHostDowntime',
                    hostUuid: this.getUuid,
                    start: this.downtimeStartTime,
                    end: this.downtimeEndTime,
                    author: this.$store.state.user,
                    comment: this.downtimeComment,
                    downtimetype: this.downtimeTypeSelected
                }
            ];
            this.sendCommand(externalCommand);
        },
        sendCommand: function(externalCommand){
            axios.post('/hosts/external_commands.json', externalCommand)
                .then(response => {
                    useToast().success(this.$t('Command successfully sent'), {
                        timeout: 7000
                    });
                    this.$emit('refresh', 'ScheduleMaintenance');
                })
                .catch(error => {
                    useToast().error(this.$t('error'), {
                        timeout: 2000
                    });
                });
        },
        getDates(){
            axios.post('/downtimes/get_dates.json')
                .then(response => {
                        let datetime = response.data.datetime[0];
                        this.downtimeStartTime = datetime.start_time;
                        this.downtimeEndTime = datetime.end_time;
                })
                .catch(error => {
                    console.log('Error: ' + error)
                });
        },
    },
    mounted(){
        this.getDates();
    },
    computed: {
        getUuid: function(){
            return this.hostuuid;
        },
        getDowntime: function(){
            return this.downtime;
        },
        getHostStatus: function(){
            return this.hoststatus;
        }
    }
}
</script>

<style scoped>

</style>
